<template>
  <b-card :img-src="image_file" img-left class="mb-3">
    <h3>{{ file.legenda }}</h3>
    <div class="storage-data border p-2">
      <span class="d-block"> Arquivo: {{ file.extra_data.basename }} </span>
      <span class="d-block"> Categoria: {{ categoria }} </span>
      <span class="d-block">
        <font-awesome-icon icon="folder-open" />
        {{ file.path }}
      </span>

      <hr class="my-3" />

      <span class="d-block">
        Tamanho: {{ file.storage_data.size | prettyBytes }}
      </span>
      <span class="d-block"> Tipo: {{ file.storage_data.mimeType }} </span>
      <span class="d-block">
        Modificado: {{ file.storage_data.time | format_date }}
      </span>
    </div>
    <pre v-if="false">{{ file }}</pre>
  </b-card>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  props: {
    file: {
      type: Object,
    },
  },
  data: () => ({
    image_file: null,
  }),
  computed: {
    categoria() {
      return this.file.categoria ? this.file.categoria.nome : "--";
    },
  },
  methods: {
    ...mapActions("files", ["ActionGetImage"]),
    async getImage() {
      this.image_file = await this.ActionGetImage(this.file);
    },
  },
  watch: {
    "file.id": {
      deep: true,
      handler: async function (value) {
        await this.getImage();
      },
    },
  },
  async created() {
    await this.getImage();
  },
};
</script>

<style lang="scss">
.card-img-left {
  max-width: 150px;
  margin-left: 1rem;
  height: 100%;
  align-self: center;
}
</style>
